import Loadable from "react-loadable"
import MainLayout from "@/layouts/MainLayout/index.tsx"
import Loading from "@/components/Loading/index.jsx"
// const createBrowserHistory=require("history").createBrowserHistory
// import { createBrowserHistory } from "history"
import { createHashHistory } from "history"

const help = Loadable({
  loader: () => import("@/pages/home/index.tsx"),
  loading: Loading,
})
const details =  Loadable({
  loader: () => import("@/pages/home/details.tsx"),
  loading: Loading,
})
const index= Loadable({
  loader: () => import("@/pages/index/index.tsx"),
  loading: Loading,
})

export const history = createHashHistory()

export const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    layout: MainLayout,
    component: index,
  },
  {
    path: "/help",
    layout: MainLayout,
    component: help,
  },
  {
    path: "/helpInfo/:type",
    layout: MainLayout,
    component: details,
  },
]
